import { t } from '../../../i18n.es.js';
import React from 'react';
import { styled, Currency } from '@teko/ui';

const Percent = styled.span `
  margin-left: 4px;
`;
const StyledCurrency = styled(Currency) `
  margin: 0 4px;
  color: #ed2101;
  font-weight: 500;
`;
const OrderValueMin = styled.span `
  margin-left: 4px;
`;
const OrderValueMax = styled(Percent) ``;
const PromotionInfo = ({ money, condition, }) => {
    if (!money)
        return null;
    return (React.createElement(React.Fragment, null,
        money.discountType === 'percent' ? (React.createElement(Percent, null,
            money.percent,
            t('% tối đa'),
            React.createElement(StyledCurrency, { value: money.maxDiscount || 0 }))) : (React.createElement(StyledCurrency, { value: money.money || 0 })),
        condition && (React.createElement(React.Fragment, null,
            condition.orderValueMin && (React.createElement(OrderValueMin, null,
                t('cho đơn hàng từ'),
                React.createElement(Currency, { value: condition.orderValueMin }))),
            condition.orderValueMax && (React.createElement(OrderValueMax, null,
                t('đến'),
                React.createElement(Currency, { value: condition.orderValueMax })))))));
};

export { PromotionInfo };
